var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_969_486)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M8.125 3.04688H5.07812C2.83446 3.04688 1.01562 4.86571 1.01562 7.10938V9.14062H4.0625V7.10938C4.0625 4.86571 5.88133 3.04688 8.125 3.04688Z",
    fill: "url(#paint0_linear_969_486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10938 1.01562V5.07812M17.2656 1.01562V5.07812M23.3594 9.14062H1.01562M23.3594 11.1719V7.10938C23.3594 4.86561 21.5405 3.04688 19.2969 3.04688H5.07812C2.83451 3.04688 1.01562 4.86561 1.01562 7.10938V19.2969C1.01562 21.5405 2.83451 23.3594 5.07812 23.3594H11.1719",
    stroke: "url(#paint1_linear_969_486)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0696 16.5433L23.2953 22.72C23.1539 24.0173 22.0583 25 20.7533 25H19.2368C17.9318 25 16.8362 24.0173 16.6948 22.72L15.9206 16.5433M15 16.4016H24.9213M21.8504 15.9764V14.8898C21.8504 13.8461 21.0043 13 19.9606 13C18.917 13 18.0709 13.8461 18.0709 14.8898V15.9764",
    stroke: "black",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53905 13.2695C6.53905 13.9707 5.97066 14.5391 5.26953 14.5391C4.56839 14.5391 4 13.9707 4 13.2695C4 12.5684 4.56839 12 5.26953 12C5.97066 12 6.53905 12.5684 6.53905 13.2695Z",
    fill: "url(#paint2_linear_969_486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9062 13.2695C10.9062 13.9707 10.3378 14.5391 9.63671 14.5391C8.93558 14.5391 8.36719 13.9707 8.36719 13.2695C8.36719 12.5684 8.93558 12 9.63671 12C10.3378 12 10.9062 12.5684 10.9062 13.2695Z",
    fill: "url(#paint3_linear_969_486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2734 13.2695C15.2734 13.9707 14.705 14.5391 14.0039 14.5391C13.3028 14.5391 12.7344 13.9707 12.7344 13.2695C12.7344 12.5684 13.3028 12 14.0039 12C14.705 12 15.2734 12.5684 15.2734 13.2695Z",
    fill: "url(#paint4_linear_969_486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53905 18.6367C6.53905 19.3378 5.97066 19.9062 5.26953 19.9062C4.56839 19.9062 4 19.3378 4 18.6367C4 17.9356 4.56839 17.3672 5.26953 17.3672C5.97066 17.3672 6.53905 17.9356 6.53905 18.6367Z",
    fill: "url(#paint5_linear_969_486)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9062 18.6367C10.9062 19.3378 10.3378 19.9062 9.63671 19.9062C8.93558 19.9062 8.36719 19.3378 8.36719 18.6367C8.36719 17.9356 8.93558 17.3672 9.63671 17.3672C10.3378 17.3672 10.9062 17.9356 10.9062 18.6367Z",
    fill: "url(#paint6_linear_969_486)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_969_486",
    x1: 1.01562,
    y1: 3.04687,
    x2: 4.68173,
    y2: 10.0115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_969_486",
    x1: 1.53513,
    y1: 1.03019,
    x2: 18.1608,
    y2: 26.6997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE56B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_969_486",
    x1: 4,
    y1: 14,
    x2: 11.9973,
    y2: 29.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_969_486",
    x1: 4,
    y1: 14,
    x2: 11.9973,
    y2: 29.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_969_486",
    x1: 4,
    y1: 14,
    x2: 11.9973,
    y2: 29.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_969_486",
    x1: 4,
    y1: 14,
    x2: 11.9973,
    y2: 29.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_969_486",
    x1: 4,
    y1: 14,
    x2: 11.9973,
    y2: 29.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C94DAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_969_486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEvent);
export default __webpack_public_path__ + "static/media/deleteEvent.2587020dee2e8f4a84a7d18979683f06.svg";
export { ForwardRef as ReactComponent };